import { Protocol } from '../Protocol';

export class TagProtocol {
  public static readonly GET_ALL_PROPORTION_TAG: string = `${Protocol.YATUNG_API_ROOT}/proportion/tag/all`; // 取得所有標籤
  public static readonly PROPORTION_TAG: string = `${Protocol.YATUNG_API_ROOT}/proportion/tag`; // 新建標籤
}
